import styled from "styled-components";
import { colors } from "@/styles/brand";

export const Container = styled.div`
  min-height: 100vh;
  background: ${colors.backgroundPeach};
`;

export const Content = styled.div`
  max-width: 1400px;
  margin: 0 auto;
  padding: 2rem;
  display: flex;
  gap: 2rem;

  @media (max-width: 968px) {
    flex-direction: column;
  }

  @media (max-width: 768px) {
    padding: 1.2rem;
  }
`;

export const MainContent = styled.div`
  flex: 1;
  min-width: 0;
`;

export const PageHeader = styled.div`
  margin-bottom: 2rem;
`;

export const PageTitle = styled.h1`
  font-size: 2.5rem;
  font-weight: 800;
  color: #333;
  margin-bottom: 0.5rem;

  @media (max-width: 768px) {
    font-size: 1.5rem;
  }
`;

export const PageSubtitle = styled.p`
  color: #666;
  font-size: 1.1rem;
`;

export const StatsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1.5rem;
  margin-bottom: 2rem;

  @media (max-width: 1200px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const StatCard = styled.div`
  background: white;
  border-radius: 16px;
  padding: 1.5rem;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  transition: all 0.3s;
  display: flex;
  align-items: center;
  gap: 1rem;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 6px 30px rgba(0, 0, 0, 0.15);
  }
`;

export const StatIcon = styled.div<{ $color: string }>`
  width: 48px;
  height: 48px;
  border-radius: 12px;
  background: ${(props) => props.$color}20;
  color: ${(props) => props.$color};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  flex-shrink: 0;
`;

export const StatValue = styled.div`
  font-size: 2rem;
  font-weight: 800;
  color: #333;
  line-height: 1;
`;

export const StatLabel = styled.div`
  color: #666;
  font-size: 0.9rem;
  font-weight: 600;
  margin-top: 0.25rem;
`;

export const SectionGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 2rem;
`;

export const Section = styled.div`
  background: white;
  border-radius: 16px;
  padding: 2rem;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
`;

export const SectionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
`;

export const SectionTitle = styled.h2`
  font-size: 1.5rem;
  font-weight: 700;
  color: #333;
`;

export const ViewAllButton = styled.button`
  padding: 0.5rem 1rem;
  background: transparent;
  color: #c8553d;
  border: 2px solid #c8553d;
  border-radius: 6px;
  font-weight: 600;
  cursor: pointer;

  &:hover {
    background: #c8553d;
    color: white;
  }
`;

export const OrderItem = styled.div`
  padding: 1rem 0;
  border-bottom: 2px solid #f0f0f0;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: #f9fafb;
    padding-left: 1rem;
    padding-right: 1rem;
    margin-left: -1rem;
    margin-right: -1rem;
    border-radius: 8px;
  }

  &:last-child {
    border-bottom: none;
  }
`;

export const OrderHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 0.5rem;
`;

export const OrderId = styled.div`
  font-weight: 600;
  color: #c8553d;
`;

export const OrderStatus = styled.span<{ $status: string }>`
  padding: 0.25rem 0.75rem;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: 600;

  ${(props) => {
    switch (props.$status) {
      case "pending":
        return `
          background: #FFE9D5;
          color: #7A3E1F;
        `;
      case "confirmed":
        return `
          background: #E0F2F3;
          color: #558B8D;
        `;
      default:
        return `
          background: #f3f4f6;
          color: #374151;
        `;
    }
  }}
`;

export const OrderDetails = styled.div`
  font-size: 0.9rem;
  color: #666;
`;

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 4rem;
`;

export const Spinner = styled.div`
  width: 50px;
  height: 50px;
  border: 5px solid #e0e0e0;
  border-top-color: #c8553d;
  border-radius: 50%;
  animation: spin 1s linear infinite;

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
`;

export const EmptyState = styled.div`
  text-align: center;
  padding: 2rem;
  color: #666;
`;

export const ReminderCard = styled.div`
  background: linear-gradient(135deg, #fff5f3 0%, #ffe9e0 100%);
  border: 2px solid #c8553d;
  border-radius: 16px;
  padding: 2rem;
  margin-bottom: 2rem;
  box-shadow: 0 4px 20px rgba(200, 85, 61, 0.15);
`;

export const ReminderHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1rem;
`;

export const ReminderIcon = styled.div`
  width: 48px;
  height: 48px;
  background: #c8553d;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  flex-shrink: 0;
`;

export const ReminderContent = styled.div`
  flex: 1;
`;

export const ReminderTitle = styled.h3`
  font-size: 1.25rem;
  font-weight: 700;
  color: #333;
  margin-bottom: 0.5rem;
`;

export const ReminderText = styled.p`
  color: #666;
  line-height: 1.6;
  margin-bottom: 1rem;
`;

export const ReminderButton = styled.button`
  padding: 0.875rem 1.5rem;
  background: #c8553d;
  color: white;
  border: none;
  border-radius: 8px;
  font-weight: 600;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.3s;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;

  &:hover {
    background: #b04731;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(200, 85, 61, 0.3);
  }
`;

export const ProfitsCard = styled.div`
  background: linear-gradient(135deg, #558b8d 0%, #467072 100%);
  border-radius: 16px;
  padding: 2.5rem;
  box-shadow: 0 4px 20px rgba(85, 139, 141, 0.3);
  margin-bottom: 2rem;
  color: white;
`;

export const ProfitsHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 2rem;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 1rem;
  }
`;

export const ProfitsTitle = styled.h2`
  font-size: 1.5rem;
  font-weight: 700;
  color: white;
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

export const RefreshButton = styled.button`
  padding: 0.625rem 1.25rem;
  background: rgba(255, 255, 255, 0.2);
  color: white;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-radius: 8px;
  font-weight: 600;
  font-size: 0.9rem;
  cursor: pointer;
  transition: all 0.3s;
  display: flex;
  align-items: center;
  gap: 0.5rem;

  &:hover:not(:disabled) {
    background: rgba(255, 255, 255, 0.3);
    border-color: rgba(255, 255, 255, 0.5);
    transform: translateY(-2px);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const ProfitsAmount = styled.div`
  font-size: 3rem;
  font-weight: 800;
  color: white;
  margin-bottom: 0.5rem;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

  @media (max-width: 768px) {
    font-size: 2.5rem;
  }
`;

export const ProfitsSubtext = styled.p`
  color: rgba(255, 255, 255, 0.9);
  font-size: 1rem;
  line-height: 1.6;
  margin-bottom: 1.5rem;
`;

export const ProfitsInfo = styled.div`
  background: rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  padding: 1.25rem;
  backdrop-filter: blur(10px);
`;

export const ProfitsInfoItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);

  &:last-child {
    border-bottom: none;
  }
`;

export const ProfitsInfoLabel = styled.span`
  color: rgba(255, 255, 255, 0.8);
  font-size: 0.9rem;
`;

export const ProfitsInfoValue = styled.span`
  color: white;
  font-weight: 600;
  font-size: 0.95rem;
`;

export const ProfitsSpinner = styled.div`
  width: 20px;
  height: 20px;
  border: 3px solid rgba(255, 255, 255, 0.3);
  border-top-color: white;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
`;

export const ProfitsError = styled.div`
  background: rgba(255, 255, 255, 0.1);
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-radius: 12px;
  padding: 1rem;
  color: rgba(255, 255, 255, 0.9);
  font-size: 0.9rem;
  text-align: center;
`;

export const LastUpdated = styled.div`
  color: rgba(255, 255, 255, 0.7);
  font-size: 0.85rem;
  margin-top: 1rem;
  text-align: center;
`;

export const ProfitsDisclaimer = styled.div`
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 8px;
  padding: 0.75rem 1rem;
  margin-top: 1rem;
  font-size: 0.8rem;
  color: rgba(255, 255, 255, 0.85);
  line-height: 1.5;
  text-align: center;

  strong {
    color: rgba(255, 255, 255, 1);
    font-weight: 600;
  }
`;
